/**
 * 聊天模块本地类型定义
 * 提供后端数据 → 前端 ChatMessage 的转换函数
 */

import type { ChatMessage } from '@/types';
import type { ChatMessageRecord } from '@/service/chat';

/**
 * 将后端消息记录转为前端 ChatMessage
 * @param record 后端消息记录
 * @returns ChatMessage（带客户端 ID 和状态）
 */
export const toChatMessage = (record: ChatMessageRecord): ChatMessage => ({
  id: String(record.id),
  role: record.role,
  content: record.content,
  timestamp: new Date(record.created_at).getTime(),
  thinking: record.thinking ?? undefined,
  status: 'completed',
});
